<script setup lang="ts">
import { useFormContainer } from "~/composables/useFormContainer";
import FormCard from "~/components/ui/FormCard.vue";
const locale = await getLocale("forms", "loan_protection");
import { INSURANCE_PACKAGES } from "~/utils/constants";
import Perks from "~/components/static/Perks.vue";

defineComponent({
  name: "LoanProtection",
});

defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
  package: { type: String, required: true },
  rate: { type: String, required: true },
  stickyButton: { type: Boolean, default: false }
});

const { FormContainer } = useFormContainer();

const emit = defineEmits(["init", "submit", "decline"]);
onMounted(() => emit("init"));
</script>

<template>
  <FormContainer :progress="progress">
    <FormCard :title="title" @submit="emit('submit')" :has-sticky-button="stickyButton" header-class="pageTitle mb-4">
      <template v-if="package == INSURANCE_PACKAGES.G">
        <p class="mb-4" v-html="locale.option1.text1.replace('%d', formatNumber(rate, null, ' '))"/>
        <p class="my-4" v-html="locale.option1.text2" />
      </template>
      <template v-else>
        <p class="" v-html="locale.option2.text1.replace('%d', formatNumber(rate, null, ' '))"/>
        <p class="my-4" v-html="locale.option2.text2" />
      </template>
      <template #link>
        <div class="text-center text-gray-700 text-sm mt-4 mb-8">
          <button data-testid="decline" class="underline inline" type="button" @click="$emit('decline')">
            {{ locale.proceed_without_protection }}
          </button>
        </div>
      </template>
    </FormCard>

    <template #bottom-out>
      <p class="italic px-4">{{ locale.disclaimer }}</p>
    </template>
  </FormContainer>
  <Perks />
</template>

<style scoped></style>
